import React from 'react'
import withForm from './form'
import Component from './component'

export default React.memo(withForm(Component))
